import React from 'react';
import PropTypes from 'prop-types';
import { Plus } from 'lucide-react';
import './CustomAddButton.css';

const AddButton = ({ onClick, text }) => {
    return (
        <button
            type="button"
            className="custom-add-button"
            onClick={onClick}
        >
            <Plus width="16px" height="16px" style={{ marginRight: '10px' }} />
            {text}
        </button>
    );
};

AddButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
};

export default AddButton;
